export default __webpack_public_path__ + "static/media/ChatButtonLarge1px.349942d1.svg";